'use client';

import { useEffect, useState } from 'react';

export function useNow(intervalMs: number): Date {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const clock = setInterval(() => setNow(new Date()), intervalMs);

    return () => clearInterval(clock);
  }, [intervalMs]);

  return now;
}
